export default "__VITE_ASSET__Dxv5EfCR__"